import { useContext } from "react";
import { Navigate } from "react-router-dom";

import AuthContext from "../../context/AuthContext";
import RoleLogin from "../LoggingForm/RoleLogin";

const ParentLoginPage = () => {
  const { user } = useContext(AuthContext);

  if (user?.role === "Parent") {
    return <Navigate to="/parent-portal/dashboard" replace />;
  }

  return (
    <RoleLogin />
  );
};

export default ParentLoginPage;
